<template>
  <ValidationObserver rules="required" v-slot="{ handleSubmit }">
    <RightSideBar v-if="isOpen" @submit="handleSubmit(onSubmit)" @close="onClose" submit="Save" :loading="isLoading"
      :disabled-button="isLoading" button-class="bg-dynamicBackBtn text-white">
      <template v-slot:title>
        <h1 class="text-darkPurple font-bold text-lg leading-5 p-0">
          Update Pay Band
        </h1>
      </template>
      <template>
        <div class="flex flex-col justify-start items-start gap-3">
          <div class="w-full">
            <TextInput class="w-full text-sm font-normal leading-5 text-darkPurple" v-model="payload.payGradeId"
              label="Pay Band Name" placeholder="Enter" :rules="['required']" />
          </div>
          <div class="w-full">
            <Select class="w-full text-sm font-normal leading-5 text-darkPurple" placeholder="--Select--"
              :options="levelOptions" v-model="payload.levelId" :value="4" :rules="['required']" label="Job Level"
              @input="onReferenceMarketRate" />
          </div>
          <div class="w-full">
            <div class="col-span-12">
              <p class="text-darkPurple">Role</p>
              <ComboBox :options="designationOptions" select @addSelectedTags="formattedDesignationTags($event)"
                @removeTag="removedDesignationTags($event)" no-custom />
            </div>
            <div v-if="!designationOptions.length && payload.levelId">
              <p class="text-flame text-xs text-bold">
                * There are no designations for the selected Level / Function
              </p>
            </div>
          </div>


          <div class="flex flex-col justify-start items-start w-full">
            <TextInput v-if="payload.referenceMarketRate" type="number"
              class="w-full text-sm font-normal leading-5 text-darkPurple" placeholder="Enter"
              v-model.number="payload.currentMarketRate" label="Current Market Rate" @input="onReferenceMarketRate" />
            <TextInput v-else min="0" type="number" class="w-full text-sm font-normal leading-5 text-darkPurple"
              placeholder="Amount" :rules="['required']" v-model.number="payload.midPoint"
              label="Annual Range Midpoint (₦)" @input="onReferenceMarketRate" />
          </div>
          <div class="w-full" v-if="payload.referenceMarketRate">
            <TextInput type="number" class="w-full text-sm font-normal leading-5 text-darkPurple" placeholder="Enter"
              v-model.number="payload.policyPercent" label="Policy Percentage (%)" @input="onReferenceMarketRate" />
          </div>
          <template v-if="payload.referenceMarketRate">
            <div class="w-full flex flex-col justify-start gap-2">
              <p class="text-sm text-jet">Target Percentile (%)</p>
              <div class="payInfo payInfo_fakeInput text-center text-darkPurple">
                <template v-if="!isFetchingPayGrade">
                  <span v-if="payload.targetPercentile">
                    {{ payload.targetPercentile }}%
                  </span>
                  <span v-else>Autocalculated</span>
                </template>
                <span v-else>Calculating....</span>
              </div>
            </div>
          </template>
          <template v-if="payload.referenceMarketRate">
            <div class="w-full flex flex-col justify-start gap-2">
              <p class="text-sm text-jet">Range Midpoint (₦)</p>
              <div class="payInfo payInfo_fakeInput text-center text-darkPurple">
                <template v-if="!isFetchingPayGrade">
                  <span v-if="payload.rangeMidPoint">
                    {{ convertToCurrency(payload.rangeMidPoint) }}
                  </span>
                  <span v-else>Autocalculated</span>
                </template>
                <span v-else>Calculating....</span>
              </div>
            </div>
          </template>
          <template>
            <div class="w-full flex flex-col justify-start gap-2">
              <p class="text-sm text-jet">Range Spread</p>
              <div class="payInfo payInfo_fakeInput text-center text-darkPurple">
                <template v-if="!isFetchingPayGrade">
                  <span v-if="payload.rangeSpread">
                    {{ payload.rangeSpread }}
                  </span>
                  <span v-else>Autocalculated</span>
                </template>
                <span v-else>Calculating....</span>
              </div>
            </div>
          </template>
          <template>
            <div class="w-full flex flex-col justify-start gap-2">
              <p class="text-sm text-jet">Range Minimum (₦)</p>
              <div class="payInfo payInfo_fakeInput text-center text-darkPurple">
                <template v-if="!isFetchingPayGrade">
                  <span v-if="payload.minimumrange">
                    {{ convertToCurrency(payload.minimumrange) }}
                  </span>
                  <span v-else>Autocalculated</span>
                </template>
                <span v-else>Calculating....</span>
              </div>
            </div>
          </template>
          <template>
            <div class="w-full flex flex-col justify-start gap-2">
              <p class="text-sm text-jet">Range Maximum (₦)</p>
              <div class="payInfo payInfo_fakeInput text-center text-darkPurple">
                <template v-if="!isFetchingPayGrade">
                  <span v-if="payload.maximumRange">
                    {{ convertToCurrency(payload.maximumRange) }}
                  </span>
                  <span v-else>Autocalculated</span>
                </template>
                <span v-else>Calculating....</span>
              </div>
            </div>
          </template>
        </div>
      </template>
    </RightSideBar>
  </ValidationObserver>
</template>

<script>
import * as _ from "lodash"
import VSelect from "vue-select"
import "vue-select/dist/vue-select.css";
import { ValidationObserver } from "vee-validate";
import Select from "@scelloo/cloudenly-ui/src/components/select";
import TextInput from "@scelloo/cloudenly-ui/src/components/text";
import RightSideBar from "@/components/RightSideBar";
import ComboBox from "@/components/ComboBox";

export default {
  components: {
    ValidationObserver,
    Select,
    VSelect,
    TextInput,
    RightSideBar,
    ComboBox
  },
  data() {
    return {
      isOpen: false,
      isLoading: true,
      isFetchingPayGrade: false,
      levelOptions: [],
      locationsArray: [],
      funtionOptions: [],
      selectedDesignations: [],
      payload: {
        payGradeId: '',
        levelId: '',
        functionIds: [],
        designationIds: [],
        orgJobGradeIds: [],
        currentMarketRate: '',
        policyPercent: '',
        targetPercent: '',
        rangeMidPoint: '',
        midPoint: '',
        rangeSpread: '',
        rangeMinimum: '',
        rangeMaximum: '',
        referenceMarketRate: null,
        applyToAllLocation: false,
        applyToAllFunction: false,
        applyToAllDesignation: false,
      }
    }
  },
  computed: {
    designationOptions() {
      const filteredFunctions = this.funtionOptions
      
      if (!filteredFunctions.length) return [];

      let designations = _.flatMap(filteredFunctions, (option) => option.designations);

      if (this.payload.levelId) {
        designations = _.filter(designations, (designation) => designation.level.id === this.payload.levelId);
      }

      return designations.map((item) => {
        const jobGrades = item.orgDesignationJobGrades || [];

        // Safely check for existing selection
        const existingSelection = this.selectedDesignations.find(d =>
          d && d.id && (d.id === item.id || (typeof d.id === 'string' && d.id.startsWith(`${item.id}_`)))
        );

        if (jobGrades.length === 0) {
          return {
            name: item.name,
            id: item.id,
            hasJobGrade: false,
            checked: !!existingSelection,
            disabled: false
          };
        }

        return jobGrades.map((grade) => {
          const gradeId = `${item.id}_${grade.orgJobGrade.id}`;
          return {
            name: `${item.name} (${grade.orgJobGrade.name})`,
            id: gradeId,
            hasJobGrade: true,
            checked: !!this.selectedDesignations.find(d => d && d.id === gradeId),
            disabled: false
          };
        });
      }).flat();
    }
  },

  methods: {
    async getFunctionDesignations() {
      await this.$_getFunctionDesignations().then(({ data }) => {
        this.funtionOptions = data.functions.map((item) => ({
          ...item,
          name: item.name,
          id: item.id,
          checked: false,
          disabled: false
        }))
      })
    },
    formattedDesignationTags(data) {
      this.selectedDesignations = data.filter(opt => opt.checked);

      this.payload.designationIds = _.uniq(
        data
          .filter(opt => opt.checked && !opt.hasJobGrade)
          .map(opt => opt.id)
      );

      this.payload.designationIds = _.uniq([
        ...this.payload.designationIds,
        ...data
          .filter(opt => opt.checked && opt.hasJobGrade)
          .map(opt => opt.id.slice(0, opt.id.lastIndexOf('_')))
      ]);

      this.payload.orgJobGradeIds = _.uniq(
        data
          .filter(opt => opt.checked && opt.hasJobGrade)
          .map(opt => opt.id.slice(opt.id.lastIndexOf('_') + 1))
      );
    },

    removedDesignationTags(removedId) {
      const option = this.designationOptions.find(opt => opt.id === removedId)
      if (option) option.checked = false
      this.payload.designationIds =
        this.payload.designationIds.filter(item => item !== removedId)
    },
    onToggle(payload) {
      this.payload = {
        ...payload.paygrade,
        minimumrange: payload.paygrade.rangeMinimum,
        maximumRange: payload.paygrade.rangeMaximum,
        midPoint: payload.paygrade.rangeMidPoint,
        rangeSpread: payload.paygrade.rangeSpread.spread,
        targetPercentile: payload.paygrade.targetPercent,
      }
      // Collect both designationIds and orgJobGradeIds
      const designationIds = payload.paygrade.designationIds ?? [];
      const orgJobGradeIds = payload.paygrade.orgJobGradeIds ?? [];

      // For selectedDesignations, include both:
      // - designationIds as-is (for designations without job grades)
      // - designationId + '_' + jobGradeId (for designations with job grades)
      this.selectedDesignations = [
        ...designationIds.map(id => ({
          id,
          checked: true
        })),
        ...orgJobGradeIds.map(jg => ({
          id: `${designationIds[0]}_${jg}`,
          checked: true
        }))
      ];

      this.isOpen = true;
    },

    onClose() {
      this.isOpen = false
      this.isLoading = false
      _.assign(this.$data.payload, this.$options.data().payload)

    },
    onReferenceMarketRate() {
      if (this.payload.referenceMarketRate) {
        this.payload.currentMarketRate = Math.abs(this.payload.currentMarketRate)
        if (this.payload.levelId && this.payload.policyPercent && this.payload.currentMarketRate) {
          this.isFetchingPayGrade = true
          const payload = {
            levelId: this.payload.levelId,
            policyPercent: this.payload.policyPercent,
            referenceMarketRate: this.payload.referenceMarketRate,
            currentMarketRate: this.payload.currentMarketRate
          }
          this.$_getReferenceMarketRate(payload).then(({ data }) => {
            this.payload = { ...this.payload, ...data.data }
            this.isFetchingPayGrade = false
          })
        }
      } else {
        this.payload.midPoint = Math.abs(this.payload.midPoint)
        if (this.payload.levelId && this.payload.midPoint) {
          this.isFetchingPayGrade = true
          const payload = {
            levelId: this.payload.levelId,
            midPoint: this.payload.midPoint,
            referenceMarketRate: this.payload.referenceMarketRate,
          }
          this.$_getNotReferenceMarketRate(payload).then(({ data }) => {
            this.payload = { ...this.payload, ...data.data }
            this.isFetchingPayGrade = false
          })
        }
      }
    },
    onSubmit() {
      this.isLoading = true
      const payload = {
        ...this.payload,
        orgId: this.$orgId,
        payGradeName: this.payload.payGradeId,
      }

      this.$_updatePayGradeById(payload).then(({ data }) => {
        this.$toasted.success(data.message, { duration: 3000 })
        this.$emit('success', data)
        this.onClose()
      }).catch((error) => {
        this.$toasted.error(error.message, { duration: 3000 })
        this.isLoading = false
      })
    },
    async getLevels() {
      await this.$_getLevels("").then(({ data }) => {
        this.levelOptions = data.levels.map(item => ({
          value: item.id, ...item
        }))
      })
    },
  },
  async created() {
    this.isLoading = true
    await this.getLevels();
    await this.getFunctionDesignations()
    this.isLoading = false
  },
};
</script>

<style lang="scss">
.rightSidebar {
  width: 540px !important;
}

.payInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;

  &_fakeInput {
    background: #f7f7ff;
    border-color: #878e99;
    padding: 10px 15px;
    height: 40px;
  }
}
</style>
